module.exports = __webpack_public_path__ + "img/none-img.2d11fb0a.svg";